/* =========================================================
   DESERT SUPPLY CLUB — theme.js
   Cart drawer, AJAX cart, mobile menu, PDP variant switcher,
   quantity controls, recover-password toggle.
   ========================================================= */
(function () {
  'use strict';

  const routes = (window.theme && window.theme.routes) || {};
  const moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  const cartType = (window.theme && window.theme.cartType) || 'drawer';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function delegate(ctx, ev, sel, fn) {
    ctx.addEventListener(ev, function (e) {
      const target = e.target.closest(sel);
      if (target && ctx.contains(target)) fn.call(target, e);
    });
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseFloat(cents.replace('.', ''));
    const value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------------- CART DRAWER ---------------- */
  const drawer = $('[data-cart-drawer]');
  const overlay = $('[data-cart-overlay]');

  function openCart() {
    if (cartType !== 'drawer' || !drawer) {
      window.location.href = routes.cart_url || '/cart';
      return;
    }
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  delegate(document, 'click', '[data-cart-toggle]', function (e) { e.preventDefault(); openCart(); });
  on($('[data-cart-close]'), 'click', closeCart);
  on(overlay, 'click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------------- MOBILE MENU ---------------- */
  const mobileMenu = $('[data-mobile-menu]');
  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  on($('[data-mobile-menu-toggle]'), 'click', openMobileMenu);
  on($('[data-mobile-menu-close]'), 'click', closeMobileMenu);

  /* ---------------- AJAX CART ---------------- */
  function refreshCartDrawer() {
    return fetch(routes.cart_url + '?section_id=cart-drawer-fragment', { credentials: 'same-origin' })
      .then(r => {
        if (!r.ok) throw new Error('Cart fetch failed');
        return r.text();
      })
      .then(html => {
        // Fallback: just reload cart contents from /cart.js
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(r => r.json())
          .then(cart => {
            updateCartCounts(cart);
            return cart;
          });
      })
      .catch(() => {
        // hard reload as last resort
        // window.location.reload();
      });
  }

  function updateCartCounts(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    const subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  }

  /* Add to cart from PDP form */
  delegate(document, 'submit', '#PdpForm', function (e) {
    e.preventDefault();
    const form = this;
    const submit = form.querySelector('[data-pdp-submit]');
    const original = submit ? submit.textContent : '';
    if (submit) { submit.textContent = 'adding…'; submit.disabled = true; }

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: new FormData(form)
    })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status >= 400) {
          alert(data.description || 'Could not add to cart');
          return;
        }
        return refreshCartDrawer();
      })
      .then(() => {
        // Reload the drawer body via section render
        return fetch(routes.cart_url, { credentials: 'same-origin' })
          .then(r => r.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('[data-cart-drawer]');
            if (newDrawer && drawer) drawer.innerHTML = newDrawer.innerHTML;
            openCart();
          });
      })
      .catch(err => { console.error(err); alert('something went sideways. try again?'); })
      .finally(() => {
        if (submit) { submit.textContent = original; submit.disabled = false; }
      });
  });

  /* Cart line item +/-/remove */
  delegate(document, 'click', '[data-cart-increment]', function () {
    const line = this.closest('[data-cart-line]');
    if (!line) return;
    const input = line.querySelector('[data-cart-quantity]');
    input.value = parseInt(input.value || '0', 10) + 1;
    changeLine(line.dataset.lineKey, parseInt(input.value, 10));
  });
  delegate(document, 'click', '[data-cart-decrement]', function () {
    const line = this.closest('[data-cart-line]');
    if (!line) return;
    const input = line.querySelector('[data-cart-quantity]');
    const next = Math.max(0, parseInt(input.value || '0', 10) - 1);
    input.value = next;
    changeLine(line.dataset.lineKey, next);
  });
  delegate(document, 'click', '[data-cart-remove]', function () {
    const line = this.closest('[data-cart-line]');
    if (!line) return;
    changeLine(line.dataset.lineKey, 0);
  });
  delegate(document, 'change', '[data-cart-quantity]', function () {
    const line = this.closest('[data-cart-line]');
    if (!line) return;
    changeLine(line.dataset.lineKey, parseInt(this.value || '0', 10));
  });

  function changeLine(key, qty) {
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(cart => {
        updateCartCounts(cart);
        // refresh whole drawer
        return fetch(routes.cart_url, { credentials: 'same-origin' })
          .then(r => r.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('[data-cart-drawer]');
            if (newDrawer && drawer) drawer.innerHTML = newDrawer.innerHTML;
          });
      })
      .catch(err => console.error('cart update failed', err));
  }

  /* ---------------- PDP — variant switcher + qty + thumbs ---------------- */
  const pdpVariantSelect = $('[data-pdp-variant-select]');
  const pdpMainImage = $('#PdpMainImage');
  const pdpPriceRow = $('#PdpPriceRow');

  function syncPdpVariant() {
    if (!pdpVariantSelect) return;
    const opt = pdpVariantSelect.options[pdpVariantSelect.selectedIndex];
    if (!opt) return;
    if (pdpMainImage && opt.dataset.image) pdpMainImage.src = opt.dataset.image;
    if (pdpPriceRow) {
      const price = opt.dataset.price;
      const compare = opt.dataset.compare;
      if (price) {
        const html = compare && compare !== price && compare !== ''
          ? '<span class="pdp-price">' + price + '</span><span class="pdp-price pdp-price--was">' + compare + '</span>'
          : '<span class="pdp-price">' + price + '</span>';
        pdpPriceRow.innerHTML = html;
      }
    }
  }
  delegate(document, 'change', '[data-pdp-option]', function () {
    if (!pdpVariantSelect) return;
    const optionIndexes = $$('[data-pdp-option]').map(el => el.value);
    Array.from(pdpVariantSelect.options).forEach((opt) => {
      const optTitle = opt.value;
      // Variant titles in Shopify are joined by ' / '
      // Best-effort match: if option values appear in title.
      const allMatch = optionIndexes.every(v => optTitle.indexOf(v) > -1 || pdpVariantSelect.options.length === 1);
      if (allMatch) { pdpVariantSelect.value = opt.value; }
    });
    syncPdpVariant();
  });

  /* Qty controls on PDP */
  delegate(document, 'click', '[data-pdp-qty-plus]', function () {
    const input = this.parentElement.querySelector('[data-pdp-qty]');
    input.value = parseInt(input.value || '1', 10) + 1;
  });
  delegate(document, 'click', '[data-pdp-qty-minus]', function () {
    const input = this.parentElement.querySelector('[data-pdp-qty]');
    input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
  });

  /* Thumb click swaps main image */
  delegate(document, 'click', '[data-pdp-thumbs] img', function () {
    if (!pdpMainImage) return;
    pdpMainImage.src = this.dataset.full || this.src;
    $$('[data-pdp-thumbs] img').forEach(el => el.removeAttribute('data-active'));
    this.setAttribute('data-active', 'true');
  });

  /* ---------------- Recover password toggle on login page ---------------- */
  delegate(document, 'click', 'a[href="#recover"]', function (e) {
    e.preventDefault();
    const target = document.getElementById('recover');
    if (target) {
      target.style.display = target.style.display === 'block' ? 'none' : 'block';
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---------------- Newsletter capture confirmation ---------------- */
  delegate(document, 'submit', '.capture-form', function () {
    const btn = this.querySelector('button');
    if (btn) setTimeout(() => { btn.textContent = 'see ya monday ✿'; }, 1200);
  });

})();
